import React from "react";
import itone from "../../assets/walkin/ITOnelogo.png";
import scg from "../../assets/feednews/scg_logo.png";

export default function Footer() {
  return (
    <div className="pclm-footer-logos">
      <img src={scg} alt="SCG Logo" className="pclm-company-logo" />
      <img src={itone} alt="IT One Logo" className="pclm-company-logo" />
    </div>
  );
}
